import config from '../config';
import { store } from '../redux/store';
import { NOT_AVAILABLE } from '../constants';
const addPageAction = (actionName, actionAttribute = {}) => {
    const nrAvailable = !!window.newrelic;
    if (nrAvailable) {
        const state = store.getState();
        const { locale, platform, byoInPlay } = config;
        const { eventId = NOT_AVAILABLE } = state.slip;
        const page = byoInPlay ? 'inplay' : 'prematch';
        window.newrelic.addPageAction(actionName, Object.assign({ locale,
            platform,
            page,
            eventId }, actionAttribute));
    }
};
export { addPageAction };
